// document.addEventListener(
//   "DOMContentLoaded",
//   function () {

//     const popup =
//       document.getElementById(
//         "zg-location-popup"
//       );

//     if (!popup) return;

//     const detectBtn =
//       document.getElementById(
//         "detect-location-btn"
//       );

//     const applyBtn =
//       document.getElementById(
//         "save-pincode-btn"
//       );

//     const closeBtn =
//       document.getElementById(
//         "zg-close-popup"
//       );

//     const message =
//       document.getElementById(
//         "zg-location-message"
//       );

//     const pincodeInput =
//       document.getElementById(
//         "manual-pincode"
//       );

//     /* -------------------------
//        PINCODES
//     ------------------------- */

//     const saifaiPins = [
//       "206130",
//       "206131",
//       "206128",
//       "206126",
//       "206127",
//       "206124",
//       "206125",
//       "206120",
//       "206123",
//       "206242",
//       "206245",
//       "206253",
//       "206001",
//       "206002",
//       "364001"
//     ];

//     const palavaPins = [
//       "421201",
//       "421202",
//       "421203",
//       "421204",
//       "421301",
//       "400612",
//       "421306",
//       "421204",
//       "421605"
//     ];

//     /* -------------------------
//        OPEN POPUP
//     ------------------------- */

//     const savedLocation =
//       localStorage.getItem(
//         "selected_location"
//       );

//     if (!savedLocation) {

//       popup.classList.add(
//         "active"
//       );

//       document.body.style.overflow =
//         "hidden";

//     } else {

//       popup.classList.remove(
//         "active"
//       );

//       document.body.style.overflow =
//         "";
//     }

//     /* -------------------------
//        CLOSE FIX
//     ------------------------- */

//     closeBtn?.addEventListener(
//       "click",
//       function () {

//         const selected =
//           localStorage.getItem(
//             "selected_location"
//           );

//         if (!selected) {

//           message.innerHTML =
//             "Please select location first";

//           return;
//         }

//         popup.classList.remove(
//           "active"
//         );

//         document.body.style.overflow =
//           "";
//       }
//     );

//     /* -------------------------
//        DETECT LOCATION
//     ------------------------- */

//     detectBtn?.addEventListener(
//       "click",
//       function () {

//         message.innerHTML =
//           "Detecting location...";

//         navigator.geolocation.getCurrentPosition(

//           async function(position) {

//             const lat =
//               position.coords.latitude;

//             const lon =
//               position.coords.longitude;

//             try {

//               const response =
//                 await fetch(
//                   `https://nominatim.openstreetmap.org/reverse?format=json&lat=${lat}&lon=${lon}`
//                 );

//               const data =
//                 await response.json();

//               let pincode =
//                 data?.address
//                   ?.postcode || "";

//               pincode =
//                 pincode.replace(
//                   /\D/g,
//                   ""
//                 );

//               applyLocation(
//                 pincode
//               );

//             } catch(error) {

//               console.log(
//                 error
//               );

//               message.innerHTML =
//                 "Unable to fetch location";
//             }

//           },

//           function() {

//             message.innerHTML =
//               "Location permission denied";
//           },

//           {
//             enableHighAccuracy:true,
//             timeout:10000,
//             maximumAge:0
//           }
//         );
//       }
//     );

//     /* -------------------------
//        PINCODE APPLY
//     ------------------------- */

//     applyBtn?.addEventListener(
//       "click",
//       function () {

//         const pincode =
//           pincodeInput.value
//             .trim()
//             .replace(/\D/g,'');

//         if (
//           pincode.length !== 6
//         ) {

//           message.innerHTML =
//             "Enter valid pincode";

//           return;
//         }

//         applyLocation(
//           pincode
//         );
//       }
//     );

//     /* -------------------------
//        APPLY LOCATION
//     ------------------------- */

//     function applyLocation(
//       pincode
//     ) {

//       let selectedLocation =
//         null;

//       if (
//         saifaiPins.includes(
//           pincode
//         )
//       ) {

//         selectedLocation =
//           "saifai";

//       } else if (
//         palavaPins.includes(
//           pincode
//         )
//       ) {

//         selectedLocation =
//           "palava";
//       }

//       if (!selectedLocation) {

//         message.innerHTML =
//           "Service not available";

//         return;
//       }

//       /* SAVE LOCATION */

//       localStorage.setItem(
//         "selected_location",
//         selectedLocation
//       );

//       localStorage.setItem(
//         "selected_pincode",
//         pincode
//       );

//       /* EVENT */

//       window.dispatchEvent(
//         new CustomEvent(
//           "locationUpdated",
//           {
//             detail:
//               selectedLocation
//           }
//         )
//       );

//       message.innerHTML =
//         "Location Selected";

//       setTimeout(() => {

//         popup.classList.remove(
//           "active"
//         );

//         document.body.style.overflow =
//           "";

//         window.location.reload();

//       }, 700);
//     }
//   }
// );

document.addEventListener(
  "DOMContentLoaded",
  function () {

    const popup =
      document.getElementById(
        "zg-location-popup"
      );

    if (!popup) return;

    const detectBtn =
      document.getElementById(
        "detect-location-btn"
      );

    const applyBtn =
      document.getElementById(
        "save-pincode-btn"
      );

    const closeBtn =
      document.getElementById(
        "zg-close-popup"
      );

    const message =
      document.getElementById(
        "zg-location-message"
      );

    const pincodeInput =
      document.getElementById(
        "manual-pincode"
      );

    const popupTitle =
    document.querySelector(
      ".zg-title"
    );

    /* -------------------------
       PINCODES
    ------------------------- */

    // const saifaiPins = [
    //   "206130",
    //   "206131",
    //   "206128",
    //   "206126",
    //   "206127",
    //   "206124",
    //   "206125",
    //   "206120",
    //   "206123",
    //   "206242",
    //   "206245",
    //   "206253",
    //   "206001",
    //   "206002",

    // ];

    // const palavaPins = [
    //   "421201",
    //   "421202",
    //   "421203",
    //   "421204",
    //   "421301",
    //   "400612",
    //   "421306",
    //   "421605",
    //   "364001",

    // ];



    // const kanpurPins = [
    //   "208010",
    //   "208007",
    //   // "364001",
    // ];


    const saifaiPins =
  window.locationPincodes?.saifai || [];
  // console.log('saifaipins',saifaiPins);

const kanpurPins =
  window.locationPincodes?.kanpur || [];
// console.log('kanpurpins',kanpurPins);

const karhalPins =
  window.locationPincodes?.karhal || [];

    /* -------------------------
       OPEN POPUP
    ------------------------- */

    const savedLocation =
      localStorage.getItem(
        "selected_location"
      );

    if (!savedLocation) {

      popup.classList.add(
        "active"
      );

      popupTitle.innerHTML =
      "Select Delivery Location";

      closeBtn.classList.add(
        "hidden"
      );

      document.body.style.overflow =
        "hidden";

    } else {

      popup.classList.remove(
        "active"
      );

      closeBtn.classList.remove(
        "hidden"
      );

      document.body.style.overflow =
        "";
    }

    /* -------------------------
       CLOSE FIX
    ------------------------- */

    closeBtn?.addEventListener(
      "click",
      function () {

        const selected =
          localStorage.getItem(
            "selected_location"
          );

        if (!selected) {

          message.className =
          "zg-message normal";

          message.innerHTML =
            "Please select location first";

          return;
        }

        popup.classList.remove(
  "active"
);

document.body.style.overflow =
  "";

/* CLEAR OLD DATA */
pincodeInput.value = "";

message.innerHTML = "";

message.className =
  "zg-message";
      }
    );

    /* -------------------------
       DETECT LOCATION
    ------------------------- */

    detectBtn?.addEventListener(
      "click",
      function () {

        message.innerHTML =
          "Detecting location...";

        navigator.geolocation.getCurrentPosition(

          async function(position) {

            const lat =
              position.coords.latitude;

            const lon =
              position.coords.longitude;

            try {

              const response =
                await fetch(
                  `https://nominatim.openstreetmap.org/reverse?format=json&lat=${lat}&lon=${lon}`
                );

              const data =
                await response.json();

              let pincode =
                data?.address
                  ?.postcode || "";

              pincode =
                pincode.replace(
                  /\D/g,
                  ""
                );

              applyLocation(
                pincode
              );

            } catch(error) {

              console.log(
                error
              );

              message.innerHTML =
                "Unable to fetch location";
            }

          },

          function() {

            message.innerHTML =
              "Location permission denied";
          },

          {
            enableHighAccuracy:true,
            timeout:10000,
            maximumAge:0
          }
        );
      }
    );

    /* -------------------------
       PINCODE APPLY
    ------------------------- */

    applyBtn?.addEventListener(
      "click",
      function () {

        const pincode =
          pincodeInput.value
            .trim()
            .replace(/\D/g,'');

        if (
          pincode.length !== 6
        ) {

          message.innerHTML =
            "Enter valid pincode";

          return;
        }

        applyLocation(
          pincode
        );
      }
    );

    /* -------------------------
       APPLY LOCATION
    ------------------------- */

    function applyLocation(
      pincode
    ) {

      let selectedLocation =
        null;

      if (
        saifaiPins.includes(
          pincode
        )
      ) {

        selectedLocation =
          "saifai";

      }
       else if (
    karhalPins.includes(pincode)
  ) {

    selectedLocation =
      "karhal";
  }
      else if (
        // palavaPins.includes(
        //   pincode
        // )
        kanpurPins.includes(
          pincode
        )
      ) {

        selectedLocation =
          // "palava";
          "kanpur";
      }

      if (!selectedLocation) {

       message.className =
          "zg-message error";

        message.innerHTML =
          "Service not available";

        return;
      }

      /* SAVE LOCATION */

      localStorage.setItem(
        "selected_location",
        selectedLocation
      );

      localStorage.setItem(
        "selected_pincode",
        pincode
      );

      /* UPDATE HEADER */

      updateHeaderLocation();

      /* UPDATE PRODUCTS */

      window.dispatchEvent(
        new CustomEvent(
          "locationUpdated",
          {
            detail:
              selectedLocation
          }
        )
      );

      message.className =
  "zg-message success";

message.innerHTML =
  "Location Selected";

/* UPDATE PRODUCT PRICE */
window.dispatchEvent(
  new CustomEvent(
    "locationUpdated",
    {
      detail:
        selectedLocation
    }
  )
);

/* CLOSE POPUP + RELOAD PAGE */
setTimeout(() => {

  popup.classList.remove(
    "active"
  );

  document.body.style.overflow =
    "";

  window.location.reload();

}, 300);
    }

    /* -------------------------
       HEADER LOCATION
    ------------------------- */

    function updateHeaderLocation() {

      const location =
        localStorage.getItem(
          "selected_location"
        );

      const pincode =
        localStorage.getItem(
          "selected_pincode"
        );

      const el =
        document.getElementById(
          "zg-current-location"
        );

      const deliveryEl =
        document.getElementById(
          "zg-delivery-time"
        );

      if (!el) return;

      if (
        location &&
        pincode
      ) {

        const formattedLocation =
          location.charAt(0)
            .toUpperCase() +
          location.slice(1);

        el.innerHTML =
          `${formattedLocation} - ${pincode}`;

        if (deliveryEl) {
          deliveryEl.style.display =
            "block";
        }

      } else {

        el.innerHTML =
          "Select Location";

        if (deliveryEl) {
          deliveryEl.style.display =
            "none";
        }
      }
    }

    /* -------------------------
       CHANGE LOCATION
    ------------------------- */

    document
  .getElementById(
    "zg-open-location-popup"
  )
  ?.addEventListener(
    "click",
    function () {

      popup.classList.add(
        "active"
      );

      popupTitle.innerHTML =
        "Change Location";

      closeBtn.classList.remove(
        "hidden"
      );

      document.body.style.overflow =
        "hidden";
    }
  );

    /* -------------------------
       INITIAL LOAD
    ------------------------- */

    updateHeaderLocation();

  }
);